import { Controller } from "@hotwired/stimulus"

// Toggles "scrolled" class on the navbar when the page is scrolled, for border/shadow effects.
export default class extends Controller {
  connect() {
    this.boundUpdate = this.update.bind(this)
    this.update()
    window.addEventListener("scroll", this.boundUpdate, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundUpdate)
  }

  update() {
    if (window.scrollY > 0) {
      this.element.classList.add("scrolled")
    } else {
      this.element.classList.remove("scrolled")
    }
  }
}
